exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2H_gTDbgFD-4NUoWsmH53Q{color:#0eb244}.AbncMD2VhhuegITwoAUVj{color:#e63236}._3RpYtkEGBLJHe76L1ddSnv{color:var(--black)}", ""]);
// Exports
exports.locals = {
	"available": "_2H_gTDbgFD-4NUoWsmH53Q",
	"busy": "AbncMD2VhhuegITwoAUVj",
	"unknown": "_3RpYtkEGBLJHe76L1ddSnv"
};